import React from 'react';

import { Icon, FlexBox, Typography, Button } from '@vp/swan';

const IconSize = '24px';

interface FlyoutTriggerProps {
  iconType: Pick<React.ComponentPropsWithoutRef<typeof Icon>, 'iconType'>['iconType'];
  label: string;
  onClick?: () => void;
}

export const FlyoutTrigger: React.FC<FlyoutTriggerProps> = (props) => {
  return (
    <Button skin="link" onClick={props.onClick} style={{ width: '100%' }}>
      <FlexBox justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
        <Typography fontSkin="body-standard">{props.label}</Typography>
        <Icon iconType="chevronRight" width={IconSize} height={IconSize} aria-hidden="true" />
      </FlexBox>
    </Button>
  );
};
